import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Chip } from '@mui/material';
import { ArrowForward as ArrowIcon } from '@mui/icons-material';
import { appColors } from '../../Config/Theme';
import { helpTopics } from '../../help/helpTopics';

interface HelpRelatedTopicsProps {
  slugs: string[];
}

const HelpRelatedTopics: React.FC<HelpRelatedTopicsProps> = ({ slugs }) => {
  const navigate = useNavigate();
  const related = slugs
    .map((s) => helpTopics.find((t) => t.slug === s))
    .filter(Boolean) as typeof helpTopics;

  if (related.length === 0) return null;

  return (
    <Box sx={{ mt: 4, pt: 3, borderTop: `1px solid ${appColors.border.default}` }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: appColors.text.heading, mb: 1.5 }}>
        Related Topics
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {related.map((topic) => (
          <Chip
            key={topic.slug}
            label={topic.title}
            icon={<ArrowIcon sx={{ fontSize: '14px !important' }} />}
            onClick={() => navigate(`/help/${topic.slug}`)}
            sx={{
              fontWeight: 500,
              fontSize: '0.8rem',
              height: 32,
              borderRadius: '16px',
              bgcolor: appColors.surface.card,
              border: `1px solid ${appColors.border.default}`,
              cursor: 'pointer',
              '&:hover': {
                borderColor: appColors.primary.main,
                bgcolor: `${appColors.primary.main}08`,
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default HelpRelatedTopics;
